if (!customElements.get("oculoplast-newsletter")) {
  customElements.define(
    "oculoplast-newsletter",
    class OculoplastNewsletter extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector("[data-oculoplast-newsletter-dialog]");
        this.closeButton = this.querySelector("[data-oculoplast-newsletter-close]");
        this.delaySeconds = Number(this.dataset.delaySeconds || 12);
        this.intervalDays = Number(this.dataset.intervalDays || 14);
        this.hasFeedback = Boolean(
          this.querySelector("[data-oculoplast-newsletter-success], [data-oculoplast-newsletter-error]"),
        );
        this.storageKey = "oculoplast-newsletter:last-dismissed";

        if (!this.dialog || !this.closeButton) return;

        this.closeButton.addEventListener("click", this.close);
        this.dialog.addEventListener("click", this.handleBackdropClick);
        this.dialog.addEventListener("close", this.rememberDismissal);

        if (this.hasFeedback) {
          this.open();
          return;
        }

        if (!this.shouldOpen()) return;
        this.timer = window.setTimeout(this.open, Math.max(0, this.delaySeconds) * 1000);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.closeButton?.removeEventListener("click", this.close);
        this.dialog?.removeEventListener("click", this.handleBackdropClick);
        this.dialog?.removeEventListener("close", this.rememberDismissal);
      }

      shouldOpen() {
        if (window.Shopify?.designMode) return false;

        try {
          const lastDismissed = Number(window.localStorage.getItem(this.storageKey) || 0);
          if (!lastDismissed) return true;
          const interval = Math.max(1, this.intervalDays) * 24 * 60 * 60 * 1000;
          return Date.now() - lastDismissed >= interval;
        } catch (_error) {
          return true;
        }
      }

      open = () => {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
      };

      close = () => {
        this.dialog?.close();
      };

      handleBackdropClick = (event) => {
        if (event.target === this.dialog) this.close();
      };

      rememberDismissal = () => {
        try {
          window.localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (_error) {
          // Storage can be unavailable in private browsing; closing still works.
        }
      };
    },
  );
}
